
import { computed, defineComponent } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import Button from '@/components/elements/Button.vue'
import NewsList from '@/components/block/NewsList.vue'

export default defineComponent({
  name: 'HomeNews',

  components: {
    NewsList,
    HeadingLv2,
    Button
  },

  setup() {
    const store = useStore()
    const router = useRouter()
    const onButtonClicked = () => {
      router.push('/news')
    }
    return {
      news: computed(() => store.getters['home/getNews']),
      onButtonClicked
    }
  }
})
